import { useState, useRef, useCallback, useEffect } from 'preact/hooks';
import {
  GoogleMap,
  InfoWindowF,
  MarkerF,
  useJsApiLoader,
} from '@react-google-maps/api'
import "./style.css";
import data from './data.json'


const MapDetail = ({infoDetail, map}) => {
  const [rating, setRating] = useState(-1)
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    // console.log(infoDetail)
    // map.setCenter({lat: infoDetail.address.lat+0.5, lng: infoDetail.address.long})
    const service = new window.google.maps.places.PlacesService(map)
    service.getDetails({ placeId: infoDetail.address.placeId,  fields:['rating', 'types']}, (res) => {
      if(res && res.rating){
        setRating(res.rating)
      }
  })
  }, [infoDetail])

  return (
    <div>
      <h2 style={{maxWidth: '200px'}}>{infoDetail.businessName}</h2>
      {rating >= 0 &&
      <p>{[...Array(5).keys()].map(a=>{
        if(a<rating)
         return `⭐`
         return ''
      }
      )} ({rating}/5)</p>}
      <p>{infoDetail.greenCard?'Green Card': 'No Green Card'}</p>
      <form onSubmit={(e)=>{
              e.preventDefault()
              const form = new FormData();
              form.append("data", JSON.stringify({Name: e.target.name.value, Email: e.target.email.value, Phone: e.target.phone.value, MapTitle: `${infoDetail.businessName} - ${infoDetail.id}`}))
              
              const options = {
                method: 'POST',
              };
              
              options.body = form;
              setLoading(true)
              fetch('https://data.scout.energy/api/v1/db/public/shared-view/59e356a5-e6e9-44ca-b6d5-e883d8ad683a/rows', options)
                .then(response => response.json())
                .then(response =>{
                  console.log(response)
                  setMessage('Thank you for your submission, we will be in touch soon')
                  setLoading(false)
                } )
              .catch(err => {
                console.error(err)
                setMessage(`Couldn't send, please try again later`)
                setLoading(false)
              });
            }}>
              <label for="name" minlength="2">
                Name
                </label><br />
                <input type="text" name="name" required />
              
              <br />
              <br />
              <label for="email">
                Email:
                
              </label><br />
              <input type="email" name="email" required  />
              <br />
              <br />
              <label for='phone'>
                Phone:
                
              </label><br />
              <input type="tel" name="phone" required minlength="6" />
              <br />
              <br />
              <button className='button' type="submit" disabled={loading}>Submit</button>
              {loading && <p style={{marginTop: '5px', maxWidth: '200px'}}>Sending...</p>}
              <p style={{marginTop: '5px', maxWidth: '200px'}}>{message}</p>
            </form>
    </div>
  )
}


const libraries = ['places']
const Map = () => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyDZA2lckirRTYQEbXgqhlmflCjZKAbbVmk', //process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY as string,
    libraries,
  })

  const mapObject = useRef()

  const onLoad = useCallback(function onLoad(map) {
    mapObject.current = map
  }, [])

  const [infoDetail, setInfoDetail] = useState(null)
  const [center, setCenter] = useState({ lat: -29.45274369336482, lng: 25.527817570904134 })

  const points = data

  // console.log(points)


  if (loadError) {
    return <div>Map cannot be loaded right now, sorry.</div>
  }

  if (isLoaded) {
    return (<>
      <GoogleMap
        mapContainerStyle={{
          height: '100%',
          minHeight: '600px',
          width: '100%',
        }}
        center={center}
        zoom={6}
        tilt={0}
        options={{
          // mapTypeId: 'satellite',
          fullscreenControl: true,
          mapTypeControl: false,
          streetViewControl: false,
          scaleControl: false,
          rotateControl: false,
          zoomControl: true,
        }}
        onLoad={onLoad}
      >
        {infoDetail && <InfoWindowF
          position={{lat: infoDetail.address.lat, lng: infoDetail.address.long}}
          onCloseClick={() => {
            // console.log('close', infoDetail.address.lat, infoDetail.address.long)
            // mapObject.current.setCenter({lat: 0, lng: 0})
            setCenter({lat: infoDetail.address.lat, lng: infoDetail.address.long})
            setInfoDetail(null)
          }}
          >
            <MapDetail infoDetail={infoDetail} map={mapObject.current} />
          </InfoWindowF>}
        {points &&
          points.length > 0 &&
          points.map((a) => {
            if(isNaN(a.address.lat) || isNaN(a.address.long)){
              console.error(a)
              return null
            }
            return (
            <MarkerF
              // icon={a.icon ? `/${a.icon}` : 'https://raw.githubusercontent.com/lykmapipo/themify-icons/master/SVG/signal.svg'}
              key={a.id}
              position={{lat: a.address.lat, lng: a.address.long}}
              onClick={() => setInfoDetail(a)}
            />
          )})}
      </GoogleMap>
      </>
    )
  }

  return (
    <div>
      <p>Loading...</p>
    </div>
  );

}

export default function App(props) {
  return (<Map {...props} />)
}
